export default __webpack_public_path__ + "static/signin-cover-58aa4ea664da064189725b653eab0869.jpg";